export default __webpack_public_path__ + "static/media/aggeroLogo.aad33849.png";